import React, { useState, useRef, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";

import Layout from "../../components/Layout";

import { apiCRMv3 } from "../../services/api";

import Swal from "sweetalert2";

const SuperComboCampaignNew = (props) => {
	const [loaded, setLoaded] = useState(false);
	const [error, setError] = useState({});
	const [name, setName] = useState("");
	const background2verticalFileRef = useRef(null);
	const background2horizontalFileRef = useRef(null);
	const background3FileRef = useRef(null);
	const background4FileRef = useRef(null);

	useEffect(() => {
		setLoaded(true);
	}, []);

	function handleCancelButton(event) {
		if (name !== "") {
			Swal.fire({
				title: "Tem certeza que deseja cancelar?",
				text: "Cancelar fará você perder todas as modificações feitas até o momento!",
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Sim, quero cancelar!",
				cancelButtonText: "Cancelar",
			}).then((result) => {
				if (result.value) {
					Swal.fire(
						"Cancelado!",
						"Você irá voltar para a tela de listagem.",
						"success"
					);

					props.history.push("/super-combo-campanhas");
				}
			});
		} else {
			props.history.push("/super-combo-campanhas");
		}
	}

	async function handleSubmitForm(event) {
		event.preventDefault();
		setLoaded(false);
		if (name === "" || !name) {
			Swal.fire({
				type: "error",
				title: "Oops...",
				text: "O nome deve ser preenchido",
			});
			setLoaded(true);
			return;
		}
		if (!background2verticalFileRef.current.files[0]) {
			Swal.fire({
				type: "error",
				title: "Oops...",
				text: "É necessário enviar a fundo para 2 produtos vertical",
			});
			setLoaded(true);
			return;
		}
		if (!background2horizontalFileRef.current.files[0]) {
			Swal.fire({
				type: "error",
				title: "Oops...",
				text: "É necessário enviar a fundo para 2 produtos horizontal",
			});
			setLoaded(true);
			return;
		}
		if (!background3FileRef.current.files[0]) {
			Swal.fire({
				type: "error",
				title: "Oops...",
				text: "É necessário enviar a fundo para 3 produtos",
			});
			setLoaded(true);
			return;
		}
		if (!background4FileRef.current.files[0]) {
			Swal.fire({
				type: "error",
				title: "Oops...",
				text: "É necessário enviar a fundo para 4 produtos",
			});
			setLoaded(true);
			return;
		}
		try {
			const formData = new FormData();
			formData.append("name", name);
			formData.append(
				"background2vertical",
				background2verticalFileRef.current.files[0]
			);
			formData.append(
				"background2horizontal",
				background2horizontalFileRef.current.files[0]
			);
			formData.append("background3", background3FileRef.current.files[0]);
			formData.append("background4", background4FileRef.current.files[0]);
			const createdSuperComboCampaign = await apiCRMv3.post(
				"/super-combo-campaign",
				formData
			);
			setLoaded(true);
			if (createdSuperComboCampaign.status === 201) {
				Swal.fire({
					type: "success",
					title: "Salvo!",
					text: "A campanha do super combo foi salva com sucesso!",
				}).then(() => props.history.push("/super-combo-campanhas"));
			} else {
				Swal.fire({
					type: "error",
					title: "Oops...",
					text: "Tivemos um problema ao salvar essa campanha do super combo. Contate o suporte!",
				});
			}
		} catch (e) {
			Swal.fire({
				type: "error",
				title: "Oops...",
				text: "Tivemos um problema ao salvar essa campanha do super combo. Contate o suporte!",
			});
			setLoaded(true);
		}
	}

	return (
		<Layout menuActive="registers" pageTitle="Nova Campanha do Super Combo">
			<div className="row">
				<div className="col-xs-12">
					<div className="card">
						<div className="card-header">
							<div className="card-title">
								Nova Campanha do Super Combo
							</div>
						</div>
						<div
							className={`card-body ${loaded ? "" : "__loading"}`}
						>
							<div className="loader-container text-center">
								<div className="icon">
									<div className="sk-wave">
										<div className="sk-rect sk-rect1"></div>
										<div className="sk-rect sk-rect2"></div>
										<div className="sk-rect sk-rect3"></div>
										<div className="sk-rect sk-rect4"></div>
										<div className="sk-rect sk-rect5"></div>
									</div>
								</div>
								<div className="title">Carregando</div>
							</div>

							<form
								className="form form-horizontal"
								onSubmit={handleSubmitForm}
							>
								<div className="section">
									<div className="section-title">Imagens</div>
									<div className="section-body">
										<div
											className={
												"form-group " +
												(error.name ? "has-error" : "")
											}
										>
											<label className="col-md-3 control-label">
												Nome
											</label>
											<div className="col-md-9">
												<input
													type="text"
													className="form-control"
													placeholder=""
													value={name}
													onChange={(event) => {
														setName(
															event.target.value
														);
													}}
												/>
											</div>
										</div>
										<div
											className={
												"form-group " +
												(error.file ? "has-error" : "")
											}
										>
											<label className="col-md-3 control-label">
												Fundo para 2 produtos na
												vertical
											</label>
											<div className="col-md-9">
												<input
													type="file"
													className="form-control"
													placeholder=""
													ref={
														background2verticalFileRef
													}
												/>
											</div>
										</div>
										<div
											className={
												"form-group " +
												(error.file ? "has-error" : "")
											}
										>
											<label className="col-md-3 control-label">
												Fundo para 2 produtos na
												horizontal
											</label>
											<div className="col-md-9">
												<input
													type="file"
													className="form-control"
													placeholder=""
													ref={
														background2horizontalFileRef
													}
												/>
											</div>
										</div>
										<div
											className={
												"form-group " +
												(error.file ? "has-error" : "")
											}
										>
											<label className="col-md-3 control-label">
												Fundo para 3 produtos
											</label>
											<div className="col-md-9">
												<input
													type="file"
													className="form-control"
													placeholder=""
													ref={background3FileRef}
												/>
											</div>
										</div>
										<div
											className={
												"form-group " +
												(error.file ? "has-error" : "")
											}
										>
											<label className="col-md-3 control-label">
												Fundo para 4 produtos
											</label>
											<div className="col-md-9">
												<input
													type="file"
													className="form-control"
													placeholder=""
													ref={background4FileRef}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="form-footer">
									<div className="form-group">
										<div className="col-md-9 col-md-offset-3">
											<button
												type="submit"
												className="btn btn-success"
											>
												Salvar
											</button>
											<button
												type="button"
												onClick={handleCancelButton}
												className="btn btn-default"
											>
												Cancelar
											</button>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default withRouter(SuperComboCampaignNew);
